import React, { useState } from 'react';
import Swal from 'sweetalert2';
import i18next from "i18next";

// Custom Hook für das Formular
export const useFormState = () => {
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [newsletter, setNewsletter] = useState(true);

    return { email, setEmail, name, setName, newsletter, setNewsletter };
};

// Funktion zum Anzeigen des SweetAlert2-Dialogs
export const showSubscriptionForm = () => {
    Swal.fire({
        title: 'Subscribe',
        html: `
            <style>
                body {
                    padding: 0!important;
                }
                .custom-button {
                    background-color: #3D73F5!important;
                    border-radius: 1.5rem!important;
                    transition-duration: 300ms!important;
                    color: white!important;
                    font-weight: bold!important;
                }

                .custom-button:hover {
                    background-color: #4169FC;
                }

                .custom-button-cancel {
                    background-color: #f53d3d!important;
                    border-radius: 1.5rem!important;
                    transition-duration: 300ms!important;
                    color: white!important;
                    font-weight: bold!important;
                }

                .custom-button-cancel:hover {
                    background-color: #d00606!important;
                }

                /* Stil für die Input-Felder */
                .input-accent {
                    width: 100%;
                    padding: 0.5rem 1rem;
                    border: 2px solid #3D73F5;
                    border-radius: 1rem;
                    margin-bottom: 1rem;
                    font-size: 1rem;
                    text-align: center;
                }
                
                .checkbox{
                padding-top: 1rem;
                padding-bottom: 1rem;
                }
                
            </style>
            <form id="subscription-form" method="post" action="https://newsletter.cordes-hosting.net/subscription/form" class="listmonk-form">
                <div>
                    <input type="hidden" name="nonce" />
                    <p><input type="email" name="email" id="email-input" class="input-accent" placeholder="E-Mail" /></p>
                    <p><input type="text" name="name" id="name-input" class="input-accent" placeholder="Name (optional)" /></p>
                  
                    <p class="checkbox">
                      <input id="15ccb" type="checkbox" name="l" checked value="15ccb3b2-7bf9-4ed9-b264-e173adfc19e9" />
                      <label for="newsletter-checkbox">${i18next.t('subscribe.checkboxtext')}</label>
                    </p>
                    
                    <p><input type="button" value="${i18next.t('subscribe.subscribebutton')}" class="custom-button" id="subscribe-button" /></p>
                </div>
            </form>
        `,
        showCancelButton: true,
        confirmButtonText: i18next.t('subscribe.subscribetext'),
        showConfirmButton: false,
        customClass: {
            confirmButton: 'custom-button',
            cancelButton: 'custom-button-cancel',
        },
        didOpen: () => {
            const confirmButton = document.querySelector('.swal2-confirm');
            confirmButton.classList.add('custom-button');
            const cancelButton = document.querySelector('.swal2-cancel');
            cancelButton.classList.add('custom-button-cancel');
            // DOM-Elemente aus dem SweetAlert2-Dialog abrufen
            const emailInput = document.getElementById('email-input');
            const nameInput = document.getElementById('name-input');
            const newsletterCheckbox = document.getElementById('newsletter-checkbox');

            // Hier können Sie Event-Listener für die Formularelemente hinzufügen
            // Beispiel: emailInput.addEventListener('change', ...)

            // Event-Handler für das Absenden des Formulars
            const subscribeButton = document.getElementById('subscribe-button');
            subscribeButton.addEventListener('click', () => {
                // Hier können Sie die Formularwerte abrufen und Ihre Validierungen durchführen
                const email = document.getElementById('email-input').value;
                const name = document.getElementById('name-input').value;
                const newsletter = document.getElementById('15ccb').checked;

                // Validierung der Felder
                if (!email || !name) {
                    Swal.showValidationMessage('Bitte füllen Sie alle erforderlichen Felder aus.');
                    return;
                }


                // Formular manuell absenden
                const form = document.getElementById('subscription-form');
                form.submit();
            });
        },
        preConfirm: () => {
            // Hier können Sie den Preconfirm-Code belassen oder entfernen, da das Formular manuell gesendet wird.
        },
    });
};

// Ihre ursprüngliche SubscriptionForm-Komponente
const SubscriptionForm = () => {
    return <div></div>;
};

export default SubscriptionForm;
